// @ts-nocheck



import { ExclamationCircleTwoTone } from '@ant-design/icons';
import { navigate } from '../../lib/routerAdapter';

import Button from 'antd/lib/button';
import notification from 'antd/lib/notification';
import moment from 'moment';
import qs from 'query-string';
import React, { Component } from 'react';
import styled from 'styled-components';
import { MonthPicker } from '../../components/ant/DatePicker';
import { Calendar } from '../../components/Calendar';

import { Section, SectionTitle } from '../../components/layout';
import Header from '../../components/layout/Header';
import { notificationLoading } from '../../components/Notifications';
import { maintenanceApi, vehicleApi } from '../../lib/api';


import { isCurrentMonth } from './../../components/Calendar/helpers';
import { setQueryParams } from './../../lib/helpers';

const Wrapper = styled.div.withConfig({ displayName: "CalendarForm__Wrapper", componentId: "sc-zoeq8f-0" })(["padding:10px;padding-top:0;"]);



const Day = styled.div.withConfig({ displayName: "CalendarForm__Day", componentId: "sc-zoeq8f-1" })(["display:flex;flex-direction:row;width:100%;"]);




const DayCount = styled.p.withConfig({ displayName: "CalendarForm__DayCount", componentId: "sc-zoeq8f-2" })(["color:", ";display:inline-block;text-align:right;"],
(props) => props.color || '#0093fe');



const DayTitle = styled.p.withConfig({ displayName: "CalendarForm__DayTitle", componentId: "sc-zoeq8f-3" })(["font-weight:normal;font-size:14px;text-transform:uppercase;color:#4f4f4f;overflow:hidden;text-overflow:ellipsis;margin-right:5px;position:relative;top:6px;text-align:right;flex:1;"]);












const DayTick = styled.div.withConfig({ displayName: "CalendarForm__DayTick", componentId: "sc-zoeq8f-4" })(["display:flex;flex-direction:row;margin:4px 0;"]);




const DayCounts = styled.div.withConfig({ displayName: "CalendarForm__DayCounts", componentId: "sc-zoeq8f-5" })(["margin:0px 4px 0 4px;padding-top:30px;display:flex;width:100%;margin-left:-22px;flex-direction:column;font-weight:500;"]);








const DayInfo = styled.div.withConfig({ displayName: "CalendarForm__DayInfo", componentId: "sc-zoeq8f-6" })(["display:flex;flex-direction:column;min-width:27px;"]);





const SpaceBetween = styled.div.withConfig({ displayName: "CalendarForm__SpaceBetween", componentId: "sc-zoeq8f-7" })(["flex-grow:1;"]);














export default class CalendarForm extends Component {
  state = {
    currentDate: new Date().toISOString(),
    days: [],
    loading: false
  };

  componentDidMount = async () => {
    let { currentDate } = qs.parse(window.location.search);
    if (currentDate) {
      this.setState(
        { currentDate },
        async () => await this.fetchData(this.state.currentDate)
      );
    } else {
      await this.fetchData(this.state.currentDate);
    }
  };

  fetchData = async (currentDate) => {
    try {
      this.setState({ loading: true });
      const days = await vehicleApi.getMaintenanceSchedule(currentDate);
      this.setState({ days, loading: false });
    } catch (e) {
      notification.error({
        message: 'Ошибка запроса данных',
        description: e.message
      });
    }
  };

  componentDidUpdate(prevProps, prevState) {}

  getDayByDate = (date) => {
    return this.state.days.find((day) => moment(day.date).isSame(date, 'day'));
  };

  renderDay = (date) => {
    const day = this.getDayByDate(date);
    if (day) {
      const {
        planCount,
        workCount,
        isOverdue,
        doneCount,
        regulationCount,
        date
      } = day;
      return (
        <Day>
          <DayInfo>
            <div>{new Date(date).getDate()}</div>
            <SpaceBetween />
            {isOverdue &&
            <ExclamationCircleTwoTone
              twoToneColor="red"
              style={{
                alignItems: "flex-end",
                fontSize: "13px",
                position: "relative",
                top: "4px",
                left: "-8px"
              }} />

            }
          </DayInfo>
          <DayCounts>
            {planCount ?
            <DayTick>
                <DayTitle>План</DayTitle>
                <DayCount>{planCount}</DayCount>
              </DayTick> :
            null}
            {workCount ?
            <DayTick>
                <DayTitle>В работе</DayTitle>
                <DayCount color="#7EAAFF">{workCount}</DayCount>
              </DayTick> :
            null}
            {doneCount ?
            <DayTick>
                <DayTitle>Выполнено</DayTitle>
                <DayCount color="#22D397">{doneCount}</DayCount>
              </DayTick> :
            null}
            {regulationCount ?
            <DayTick>
                <DayTitle>Регламент</DayTitle>
                <DayCount color="#A1C1FF">{regulationCount}</DayCount>
              </DayTick> :
            null}
          </DayCounts>
        </Day>);

    }
    return null;
  };

  renderMonthPicker = () =>
  <MonthPicker
    format="MMMM YYYY"
    value={moment(this.state.currentDate)}
    placeholder="Период графика"
    onChange={(value, dateString) => {
      const currentDate = value ?
      moment(value).utc().toISOString() :
      new Date().toISOString();
      setQueryParams({ currentDate });
      this.setState({ currentDate }, () => {
        this.fetchData(this.state.currentDate);
      });
    }} />;



  handlePrint = async () => {
    try {
      notificationLoading({
        key: 'printing',
        description: 'Подготовка отчета для скачивания...'
      });
      await maintenanceApi.printSchedule();
    } catch (error) {
      notification.error({
        message: error.description,
        description: error.message
      });
    } finally {
      notification.destroy('printing');
    }
  };

  render() {
    const { loading, currentDate } = this.state;
    const windowDate = new Date(currentDate);
    return (
      <>
        <Header
          left={
          <>
              <h1 style={{ whiteSpace: 'nowrap', margin: '0 40px 0 0' }}>
                График ТО за
              </h1>
              {this.renderMonthPicker()}
            </>
          }
          right={
          <Button type="primary" onClick={this.handlePrint}>
              Печать графика ТО
            </Button>
          } />

        <Section>
          <SectionTitle>
            {moment(windowDate).format('MMMM YYYY').toLocaleUpperCase()}
          </SectionTitle>
          <Wrapper>
            <Calendar
              loading={loading}
              onClick={(date) =>
              isCurrentMonth(windowDate, date) ?
              navigate(
                `/maintenances/schedule/${date.valueOf() + 43200000}`
              ) :
              undefined
              }
              windowDate={windowDate}
              renderDay={this.renderDay} />

          </Wrapper>
        </Section>
      </>);

  }
}
